var exports = {
  "kL": "x4ddf2309--075e13--container",
  "vR": "x4ddf2309--075e13--tabs",
  "Mf": "x4ddf2309--075e13--tab",
  "qr": "x4ddf2309--075e13--footer",
};

module.exports = exports;
